export const isNumber = (v: any): boolean => typeof v === 'number';

export const toInt = (v: string): number => {
  const value = parseInt(v, 10);

  if (Number.isNaN(value)) {
    return 0;
  }

  return value;
};
